module.exports = __webpack_public_path__ + "static/media/gp.8fc39c39.svg";